import { getSensorData } from '../api/SensorDetailsAPIService'
import { TWS_API_URL } from '../environment/apis.config'
import { getAccessToken } from '../utils/auth.util'
import { SurfaceObsAPIParser } from '../utils/SurfaceObsUtils'
import { timeouts } from './RequestTimeouts'

const API_ENDPOINT = TWS_API_URL + '/weatherobs'
const radius = 100

const SurfaceObsAPI = async (
  latitude: string,
  longitude: string,
  signal: AbortSignal,
  controller: AbortController,
  currProfile : string = "default"
) => {
  const timeoutId = setTimeout(() => {
    controller.abort()
  }, timeouts.surfaceObs)

  try {
    const requestBody = await getSensorData()
    const intelToken: any[] = []
    const tempestToken: any[] = []
    requestBody.forEach((element: { sensorType: string; identity: any }) => {
      if (element.sensorType === 'Intellisense') {
        intelToken.push(element.identity)
      } else if (element.sensorType === 'Tempest') {
        tempestToken.push(element.identity)
      }
    })

    const token = await getAccessToken()
    const response = await fetch(
      `${API_ENDPOINT}/${latitude}/${longitude}?radius=${radius}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          inteldevice: intelToken,
          tempestToken: tempestToken,
          profile : currProfile
        }),
        signal,
      }
    )

    clearTimeout(timeoutId)

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`)
    }

    const data = await response.json()
    return SurfaceObsAPIParser(data)
  } catch (error) {
    clearTimeout(timeoutId)
    // Rethrow error
    throw new Error(`SurfaceObsAPI request timed out. Please try again.`)
  }
}

export function SurfaceObsAPIIconVisibility(
  feature: any,
  visibleSurfaceSensors : [],
  visibleElevatedSensors : [],
  activeMonitor: boolean = false,
  activeSensorId: any
): boolean {

  let sensorIdentifier =  feature.properties?.SensorType?.value + '-' +  feature.properties?.StationID?.value
  if (activeMonitor) {
    if (activeSensorId.hasOwnProperty(sensorIdentifier)) return true
  }
  const sensorTypeValue = feature?.properties?.SensorType?.value || "NA"

  if(feature?.elevated){
    if (sensorTypeValue && visibleElevatedSensors.includes(sensorTypeValue)) return true
  }
  else{
    if (sensorTypeValue && visibleSurfaceSensors.includes(sensorTypeValue)) return true
  }  
  
  return false
}

export const VerticalProfileAPI = async (defaultLocation: { latitude: any; longitude: any }) => {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => {
    controller.abort()
  }, timeouts.verticalProfile)
  try {
    const encodedLatitude = defaultLocation.latitude //.replace('.','%2E')// encodeURIComponent(defaultLocation.latitude);
    const encodedLongitude = defaultLocation.longitude //.replace('.','%2E') //encodeURIComponent(defaultLocation.longitude);
    const token = await getAccessToken()
    const url = `${API_ENDPOINT}/verticalprofile`

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        lat: encodedLatitude,
        long: encodedLongitude,
        radius: radius,
      }),
      signal: controller.signal,
    })

    clearTimeout(timeoutId)

    if (!response.ok) {
      throw new Error(`Network error: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    clearTimeout(timeoutId)
    console.error('Error fetching vertical profile data', error)
    throw new Error('Error fetching vertical profile data')
  }
}

export const ElevatedObsAPI = async (
  latitude: string,
  longitude: string,
  signal: AbortSignal,
  controller: AbortController
) => {  
  const timeoutId = setTimeout(() => {
    controller.abort()
  }, timeouts.elevatedObs)  
  try {
    const intelToken: never[] = []
    const tempestToken: never[] = []

    let url = TWS_API_URL + "/elevatedobs"
   
    const token = await getAccessToken()
    const response = await fetch(
      `${url}/${latitude}/${longitude}?radius=${radius}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          inteldevice: intelToken,
          tempestToken: tempestToken,
        }),
        signal,
      }
    )

    clearTimeout(timeoutId)

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`)
    }

    const data = await response.json()
    return SurfaceObsAPIParser(data, true)
  } catch (error) {    
    clearTimeout(timeoutId)
    // Rethrow error
    throw new Error(`SurfaceObsAPI request timed out. Please try again.`)
  }
}

export default SurfaceObsAPI
